import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'

import { selectors as OrganizationSelectors } from 'data/organizations'
import { dataFetched, makesQueries } from 'data/graphql'
import { organizationAttrsFragment } from 'remote/organizations'

const organizationWithAdminChannelsQuery = gql`
  query OrganizationWithAdminChannels($organizationId: ID!) {
    showOrganization(id: $organizationId) {
      ...organizationAttrs
      adminChannels {
        __typename
        id
        name
        type
        permissions {
          read
          write
          manage
          organize
          sharePublicly
          shareToIntegrations
        }
      }
    }
  }
  ${organizationAttrsFragment}
`

const providesAdminChannels = compose(
  withState('adminChannelsFetchState', 'setFetchState', {
    loading: false,
    error: false,
    pristine: true,
  }),
  connect(
    state => ({
      organizationId: OrganizationSelectors.getOrganizationId(state),
    }),
    {
      dataFetched,
    }
  ),
  makesQueries({
    query: organizationWithAdminChannelsQuery,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnQueryFromProps: ({ setFetchState }) => () =>
      setFetchState({ loading: true, error: null, pristine: false }),
    getOnResultFromProps: ({ dataFetched, setFetchState }) => ({
      result,
      meta,
    }) => {
      dataFetched(result.data.showOrganization, meta)
      setFetchState({ loading: false, error: null, pristine: false })
    },
    getOnErrorFromProps({ setFetchState }) {
      return ({ error }) => {
        setFetchState({ loading: false, error, pristine: false })
      }
    },
  })
)

export default providesAdminChannels
